// Plot.tsx
//
// Thin wrapper around react-plotly.js's factory so the app pulls in only
// the basic Plotly bundle (scatter / bar / pie) instead of the full
// distribution, which ships a mapbox-gl-based map renderer we don't use.
// Dropping mapbox-gl:
//   - eliminates ~700KB from the shipped JS bundle
//   - removes mapbox-gl from our third-party license audit
//
// Use this component instead of `import Plot from 'react-plotly.js'`.
import createPlotlyComponent from 'react-plotly.js/factory';
import { babelModuleDefault } from '../utils/babelModuleDefault';
import Plotly from 'plotly.js-basic-dist';

const Plot = babelModuleDefault(createPlotlyComponent)(Plotly);

export default Plot;
